module.exports = __webpack_public_path__ + "img/LU.3d5a09d6.svg";